<template>
  <!--  预算编制-->
  <div style="width:100%">

    <van-collapse v-model="activeNames">
      <van-collapse-item :title="`基本信息（${inputForm.code}）`" name="1">
        <van-field v-model="inputForm.code" label="单据编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.name" label="单据名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.paymentCompanyName" label="付款公司" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.mainstay" label="费用承担对象" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorDeptName" label="申请部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requestUserName" label="报销人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.projectName" label="所属项目" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.budgetControlName" label="预算控制" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requestAmount" label="报销总额（元）" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorCompanyName" label="申请公司" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.businessTime" label="申请日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.budgetAnnual" label="预算年度" v-if="inputForm.budgetControl === '1'" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.specialProjectName" label="专项预算项目" v-if="inputForm.budgetControl === '2'" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field label="事前审批单" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <b-table v-show="inputForm.erpBusinessDTOList&&inputForm.erpBusinessDTOList.length>0"  class="bgc-dark" small head-variant="dark" responsive bordered
                 :items="inputForm.erpBusinessDTOList" :fields="fields">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:cell(businessInfo)="data">
            <div style="color: #4caedc" @click="showDetail(data.item.businessInfo)">{{ data.item.businessInfo }}</div>
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
        <div style="padding-left: 16px;" v-show="inputForm.attachList2&&inputForm.attachList2.length > 0">
          <p>事前相关流程</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList2" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field v-model="inputForm.personYearAmount" label="报销人本年累计（元）" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.reversalAmount" label="冲账金额（元）" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.paymentAmount" label="付现金额（元）" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.payeeName" label="收款人名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remarks" label="报销事由" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px;" v-show="inputForm.attachList&&inputForm.attachList.length > 0">
          <p>相关附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field label="详细信息" label-width="100px" readonly>
          <template #button>
            <van-button plain type="default" @click="viewClaim">查看明细</van-button>
          </template>
        </van-field>
        <van-field label="预算信息" label-width="100px" readonly>
          <template #button>
            <van-button plain type="default" @click="viewBudget">查看明细</van-button>
          </template>
        </van-field>
      </van-collapse-item>
      <van-collapse-item title="发票信息" name="2" v-show="inputForm.costInvoiceDTOList&&inputForm.costInvoiceDTOList.length>0">
        <div v-for="(data, index) in inputForm.costInvoiceDTOList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">发票号码</div>
              <div class="m-row-content">{{ data.invoiceNum }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">发票类型</div>
              <div class="m-row-content">{{ data.invoiceType }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">发票金额(元)</div>
              <div class="m-row-content">{{Number(data.amount).toFixed(2) }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="冲账明细" name="3" v-if="inputForm.payeeType=='2'&&inputForm.costRequestReserveRepaymentDTO&&inputForm.costRequestReserveRepaymentDTO.costRequestReserveRepaymentDetailList">
        <div v-for="(data, index) in inputForm.costRequestReserveRepaymentDTO.costRequestReserveRepaymentDetailList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">借款单编号</div>
              <div class="m-row-content">{{ data.reserveFundsCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">借款金额(元)</div>
              <div class="m-row-content">{{ Number(data.fundsAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">未还款金额(元)</div>
              <div class="m-row-content">{{ Number(data.noRepaymentAmount).toFixed(2)  }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">本次还款金额(元)</div>
              <div class="m-row-content">{{Number(data.thisRepaymentAmount).toFixed(2)  }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import QueryInfoService from '@/api/system/queryInfoService'

export default {
  name: "claimCommon",
  data(){
    return {
      activeNames: ['1', '2', '3', '4', '5'],
      inputForm:{
        id:'',
        code:'',
        operatorCompanyName:'',
        operatorDeptName:'',
        businessTime:'',
        requestUserName:'',
        projectName:'',
        mainstayType:'',
        mainstayObj:'',
        mainstayCompanyId:'',
        paymentCompanyId:'',
        operatorName:'',
        createDate:'',
        attachList2:[],
        type:'',
        name:'',
        contractName:'',
        totalMaterialAmount:'',
        contractAmount:'',
        totalRequestAmount:'',
        payeeType:'',
        payeeName:'',
        payeeBank:'',
        payeeBankAccount:'',
        payeePerson:'',
        requestAmount:'',
        requestBigAmount:'',
        requestRateAmount:'',
        paymentAmount:'',
        attachList3:[],
        invoiceAmount:'',
        invoiceBigAmount:'',
        invoiceRateAmount:'',
        countersignCode:'',
        countersignDate:'',
        countersignContent:'',
        remarks:'',
        attachList:[],
        workloadEstimateDetailList:[],
        budgetControl:'',
        budgetAnnualId:'',
        specialProjectName:'',
        costBudgetDTOList:[],
        costRequestChargeDetailDTOList:[],
        costInvoiceDTOList:[],
        erpBusinessDTOList:[],
      },
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'businessInfo', label: '业务信息', minWidth: '120px'},
      ]
    }
  },
  created() {
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    init(data) {
      this.$nextTick(()=>{
        this.inputForm = data
        if(data.mainstayType=='1'){
          this.inputForm.mainstay=data.mainstayCompanyName+'-'+data.mainstayDeptName
        }else {
          this.inputForm.mainstay=data.mainstayCompanyName
        }
        this.inputForm.createByName=data.createBy.name
        //查询字典
        this.getDict([
          ['cost_contract_budget_control', 'budgetControl'],
        ])
        const amounts = [
          [this.inputForm.personYearAmount, 'personYearAmount'],
          [this.inputForm.requestAmount, 'requestAmount'],
          [this.inputForm.reversalAmount, 'reversalAmount'],
          [this.inputForm.paymentAmount, 'paymentAmount'],
        ].map(([value, formField]) => {
          this.$set(this.inputForm, `${formField}`, Number(value).toFixed(2));
        });
        this.updateDictNames(this.inputForm.costEventClaimDetailDTOList,{cost_business_type:'businessType'})
        this.updateDictNames(this.inputForm.costEventClaimDetailDTOList,{cost_fee_item:'feeType'})
        this.inputForm.createDate =  this.inputForm.createDate.slice(0,10)
      })
    },
    // 数据字典获取
    getDict(dicts){
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Name`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      });
    },
    // 将数字转为大写
    numberToChinese(n) {
      if (n == 0) {
        return "零";
      }
      if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
        return "";
      var unit = "千百拾亿千百拾万千百拾元角分", str = "";
      n += "00";
      var p = n.indexOf('.');
      if (p >= 0)
        n = n.substring(0, p) + n.substr(p + 1, 2);
      unit = unit.substr(unit.length - n.length);
      for (var i = 0; i < n.length; i++)
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
      return str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    },
    // 计算比例
    getPercent(num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0 ? "0" : (Math.round(num / total * 10000) / 100.00);
    },

    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Name`, dictItem.label);
            }
          }
        }
      });
    },
    viewClaim() {
      const fieldsList=[
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'businessTypeName', stickyColumn: true, label: '业务类型'},
        {key: 'feeContent',  label: '费用说明'},
        {key: 'businessDate',  label: '发生日期'},
        {key: 'requestAmount',  label: '报销金额（元）'},
        {key: 'budgetSubjectCode',  label: '预算科目编号'},
        {key: 'budgetSubjectFullName',  label: '预算科目名称'},
        {key: 'budgetAmount',  label: '预算金额（元）'},
        {key: 'budgetUsedAmount',  label: '预算已使用金额（元）'},
        {key: 'accountSubjectFullName',  label: '核算科目'},
        {key: 'remarks',  label: '备注'},
      ]

      this.$router.push({
        path: 'cost_claim_detail_table',
        query: {
          fieldsList: fieldsList,
          dataList: this.inputForm.costEventClaimDetailDTOList
        }
      })
    },
    viewBudget() {
      const fieldsList=[
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'budgetSubjectCode', stickyColumn: true, label: '预算科目编码'},
        {key: 'budgetSubjectName',  label: '预算科目名称'},
        {key: 'budgetAmount',  label: '预算金额（元）'},
        {key: 'budgetUsedAmount',  label: '预算已使用金额（元）'},
        {key: 'budgetApportionAmount',  label: '预算分摊金额（元）'},
        {key: 'budgetBalance',  label: '预算余额（元）'},
      ]
      this.$router.push({
        path: 'cost_claim_detail_table',
        query: {
          fieldsList: fieldsList,
          dataList: this.inputForm.costBudgetDTOList
        }
      })
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>
/** {
  margin: 0;
  padding: 0;
}*/
.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  margin: 0!important;
  padding: 0!important;
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
